const allCardOverlay = document.querySelectorAll(".card-overlay__card");
const modalButton = document.querySelector(
  ".wp-block-jormi-blocks-modal button",
);
const modalVideo = document.querySelector(".wp-block-jormi-blocks-modal video");
const modalTitle = document.querySelector(".jormi-modal__header h2");

allCardOverlay.forEach((card) => {
  card.addEventListener("click", () => {
    const dataValue = card.dataset.hsOverlay;
    modalButton.dataset.hsOverlay = dataValue;

    modalVideo.src = card.dataset.url;
    modalVideo.poster = card.dataset.poster || "";

    const client = card.dataset.client || "";
    const heading = card.dataset.heading || "";
    modalTitle.innerHTML =
      client + (heading ? " <em>" + heading + "</em>" : "");

    const modalEl = document.querySelector(dataValue);
    if (modalEl) {
      modalEl.addEventListener(
        "open.hs.overlay",
        function playOnOpen() {
          modalEl.removeEventListener("open.hs.overlay", playOnOpen);
          modalVideo.play().catch(() => {});
        },
      );
    }
  });
});
